<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.86829 8.64855C10.254 8.23529 10.7986 8 11.3694 8H37.9637C39.0883 8 40 8.89543 40 10V30C40 31.1046 39.0883 32 37.9637 32H11.3694C10.7986 32 10.254 31.7647
      9.8683 31.3514L0.535235 21.3514C-0.178411 20.5868 -0.178412 19.4132 0.535234 18.6486L9.86829 8.64855ZM19.408 14.4078C19.9517 13.8641 20.8334 13.8641 21.3771 14.4078L25
      18.0307L28.6229 14.4078C29.1666 13.8641 30.0483 13.8641 30.592 14.4078C31.1358 14.9516 31.1358 15.8332 30.592 16.377L26.9692 19.9999L30.5922 23.623C31.1359 24.1668
      31.1359 25.0484 30.5922 25.5922C30.0484 26.1359 29.1668 26.1359 28.623 25.5922L25 21.9691L21.377 25.5922C20.8332 26.1359 19.9516 26.1359 19.4078 25.5922C18.8641 25.0484
      18.8641 24.1668 19.4078 23.623L23.0309 19.9999L19.408 16.377C18.8642 15.8332 18.8642 14.9516 19.408 14.4078Z"
      fill="white"
    />
  </svg>
</template>
